import React from "react";
import { Check, ArrowRight, Sparkles, Droplets, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: "czyszczenie-co",
  title: "Czyszczenie Instalacji C.O.",
  description: "Przywracamy pełną sprawność Twojej instalacji grzewczej poprzez usunięcie nagromadzonych osadów i zgorzeliny. Nasz proces czyszczenia hydrodynamicznego eliminuje zimne strefy w grzejnikach, redukuje hałas w systemie i znacząco poprawia cyrkulację czynnika grzewczego.",
  icon: Droplets,
  beforeImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/central_heating_sludge_clogged.png",
  afterImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/central_heating_system_cleaned_and_optimized.png",
  specs: [{
    label: "Metoda",
    value: "Płukanie hydrodynamiczne (Flow Flushing)"
  }, {
    label: "Preparaty",
    value: "Inhibitory korozji marek Fernox/Sentinel"
  }, {
    label: "Efekt",
    value: "Wzrost sprawności o ok. 15-25%"
  }, {
    label: "Standard",
    value: "Zgodnie z brytyjską normą BS 7593"
  }]
}, {
  id: "plukanie-grzejnikow",
  title: "Płukanie i Odmulanie Grzejników",
  description: "Usuwamy czarny szlam i kamień, które blokują przepływ ciepła. Dzięki precyzyjnegu płukaniu pulsacyjnemu, każdy element systemu odzyskuje swoją nominalną moc grzewczą. To najszybszy sposób na przywrócenie komfortu cieplnego w Twoim domu.",
  icon: Sparkles,
  beforeImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/radiator_blocked_by_black_sludge.png",
  afterImg: "https://hydroflush.pl/wp-content/uploads/2026/07/A149E8C0-3BC3-4317-9DB5-B2A9A06F37B9.png?v=ws7dqcsdbwi",
  specs: [{
    label: "Technologia",
    value: "Urządzenia pulsacyjne Rems / Rothenberger"
  }, {
    label: "Zastosowanie",
    value: "Grzejniki stalowe, aluminiowe, żeliwne"
  }, {
    label: "Czas pracy",
    value: "Realizacja w 1 dzień roboczy"
  }, {
    label: "Zaleta",
    value: "Równomierne nagrzewanie całej powierzchni"
  }]
}, {
  id: "usuwanie-kamienia",
  title: "Usuwanie Kamienia i Konserwacja",
  description: "Zabezpiecz swój kocioł lub pompę ciepła przed niszczącym działaniem twardej wody. Profesjonalna dekalcyfikacja zapobiega kosztownym awariom wymienników ciepła i pomp obiegowych, wydłużając żywotność całej infrastruktury grzewczej o wiele lat.",
  icon: ShieldCheck,
  beforeImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/heat_exchanger_limescale_crust.png",
  afterImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/heat_exchanger_limescale_removed.png",
  specs: [{
    label: "Proces",
    value: "Dekalcyfikacja chemiczna ciśnieniowa"
  }, {
    label: "Bezpieczeństwo",
    value: "Środki neutralne dla uszczelek i miedzi"
  }, {
    label: "Zasięg",
    value: "Pszczyna i powiat pszczyński"
  }, {
    label: "Cel",
    value: "Ochrona przed awarią i spadek kosztów"
  }]
}];
export default function CustomCleaningSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="56219" id="kompleksowa-opieka-nad-systemem-co" ref={ref} className="relative w-full py-24 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[10%] left-[-10%] w-[40%] h-[40%] bg-primary/5 rounded-full blur-[120px]" />
        <div className="absolute bottom-[10%] right-[-10%] w-[40%] h-[40%] bg-accent/20 rounded-full blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className={`text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-6 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            Czysta instalacja – <span className="text-primary">niższe rachunki</span>
          </h2>
          <p className={`text-lg text-muted-foreground font-sans transition-all duration-700 delay-100 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            Zadbaj o wydajność swojego ogrzewania dzięki profesjonalnemu płukaniu
            Nasze specjalistyczne zabiegi konserwacyjne przywracają systemom grzewczym ich pierwotną sprawność
          </p>
        </div>

        <div className="space-y-24">
          {services.map((service, index) => <div key={service.id} data-index={index} className={`flex flex-col lg:flex-row gap-12 items-center ${index % 2 === 1 ? "lg:flex-row-reverse" : ""} transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"}`} style={{
          transitionDelay: `${index * 150}ms`
        }}>
              {}
              <div className="w-full lg:w-1/2 h-[400px] md:h-[500px] rounded-xl overflow-hidden shadow-2xl border border-border/50 relative group">
                <img src={service.afterImg} alt={`Efekt po czyszczeniu: ${service.title}`} className="h-full w-full object-cover" />
              </div>

              {}
              <div className="w-full lg:w-1/2 space-y-8">
                <div className="space-y-4">
                  <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-xl text-primary mb-2 shadow-sm">
                    <service.icon className="w-6 h-6" />
                  </div>
                  <h3 className="text-3xl font-bold text-foreground tracking-tight">{service.title}</h3>
                  <p className="text-muted-foreground leading-relaxed font-sans">
                    {service.description}
                  </p>
                </div>

                <div className="bg-card/50 backdrop-blur-sm rounded-xl border border-border overflow-hidden shadow-md">
                  <Table>
                    <TableHeader>
                      <TableRow className="hover:bg-transparent border-border/50">
                        <TableHead className="w-1/3 text-primary font-bold font-mono text-xs uppercase tracking-wider">Parametr</TableHead>
                        <TableHead className="text-primary font-bold font-mono text-xs uppercase tracking-wider">Szczegóły</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {service.specs.map((spec, i) => <TableRow key={i} data-index={i} className="hover:bg-muted/30 border-border/50">
                          <TableCell className="font-semibold text-foreground/90 font-sans">{spec.label}</TableCell>
                          <TableCell className="text-muted-foreground font-mono text-sm">{spec.value}</TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>

                <div className="pt-2">
                  <Button asChild className="rounded-full px-8 bg-gradient-to-r from-primary to-chart-2 hover:shadow-lg hover:shadow-primary/20 transition-all duration-300" size="lg">
                    <Link to="/ContactPage">
                      Zamów darmową wycenę <ArrowRight className="ml-2 w-4 h-4" />
                    </Link>
                  </Button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}